import { METHODS, request } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/assets/`, { params }),
  update: (params: Record<string, unknown>) => request(METHODS.PUT, `/assets/`, { params }),
  getURL: (params = {}) => request(METHODS.GET, `/assets/export/`, { params }),
};
